export default __webpack_public_path__ + "static/media/80s_dashed_border.5985df15.svg";